import { createContext } from "react";

export const ServiceDetailModalContext = createContext();
